stimulusApp.register(
  "weather",
  class extends Stimulus.Controller {
    static targets = ["chip", "panel"]
    static values = { opened: Boolean }

    connect() {
      Activity.track(this.identifier, "show")
      HB.useOuterClick(this, { onClose: () => this.close() })
    }

    toggle() {
      this.openedValue = !this.openedValue
    }

    close() {
      this.openedValue = false
    }

    openedValueChanged(opened) {
      this.panelTarget.classList.toggle("weather--panel_opened", opened)
      this.chipTarget.setAttribute("aria-expanded", opened)
      if (opened) {
        Activity.track(this.identifier, "open")
      } else if (this.panelTarget.contains(document.activeElement)) {
        this.chipTarget.focus()
      }
    }
  },
)
